const state = () => ({
  servers: {},
  lastServerId: null,
  blockedServerIds: [],
});

export default state;
